<script setup>
defineProps({
  content: {
    type: Object,
    required: true,
  },
  mobileGap: {
    type: Boolean,
    default: false,
  },
  withoutLead: {
    type: Boolean,
    default: false,
  },
  isStaticPage: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div
    :class="{ 'article-content--no-padding': isStaticPage }"
    class="article-content"
  >
    <PostContent
      :content="content.content"
      :is-article="!isStaticPage"
      :is-static-page="isStaticPage"
      :mobile-gap="mobileGap"
      :no-lead-article="withoutLead"
    />
    <slot></slot>
  </div>
</template>

<style lang="postcss" scoped>
.article-content {
  overflow: hidden;
  padding-bottom: 80px;

  @media (--small-vp) {
    padding-bottom: 40px;
  }

  &--no-padding {
    padding-bottom: 0;
  }
}
</style>
